import { ArticleCommentInput } from "../../models/articleComment"

export const articleCommentInputDefault: ArticleCommentInput = {
    MessageText: ""
}
